import { CallApi } from '@/api/call';
import { snackbarProgrammatic } from '@/components/snackbar';
import { State } from '@/stores/calls/state';
import { ActionContext, ActionTree } from 'vuex';

const callApi = new CallApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public loadMyCallsAsync = async (context: ActionContext<State, any>) => {
        try {
            const result = await callApi.getMyCallsAsync();

            context.commit('setNextAvailableCall', result.nextAvailableCall);
            context.commit('setCallbacks', result.callbacks);
            context.commit('setActiveCalls', result.activeCalls);
        } catch (e) {
            if (e instanceof Error) {
                snackbarProgrammatic.open({ message: e.message, type: 'is-danger' });
            } else {
                snackbarProgrammatic.open({ message: 'Could not load calls.', type: 'is-danger' });
            }
        }
    }
}
